export const standardWidgetProps = {
    readonly: { type: Boolean, optional: true },
    record: { type: Object },
};
